module.exports = __webpack_public_path__ + "img/Récupérateur de pente.42526b1e.jpg";